"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.referenceFragment = void 0;
exports.referenceFragment = `
  fragment reference on Reference {
    id
    bosApiId
    ifsId
    pimId
    pimCode
    santanderId
  }
`;
//# sourceMappingURL=reference.js.map